export const STORAGE_RETAIL_CLASS = 'victory_class';
export const STORAGE_PRESENCE = 'victory_presence';
export const STORAGE_WPRESENCE = 'victory_wpresence';
export const STORAGE_WLEAVE = 'victory_wleave';
export const STORAGE_LEAVE = 'victory_leave';
export const STORAGE_MISSION = 'victory_mission';
export const STORAGE_SCAN_ORDER = 'victory_scan_order';
export const STORAGE_PROFILE = 'victory_profile';
export const STORAGE_NOUTLET = 'victory_new_outlet';
export const STORAGE_ORDER_WSMM = 'victory_order_wsmm';
export const STORAGE_ORDER_BERSAMA = 'victory_order_bersama';

export function getJSONStorage(key) {
  try {
    let m_data = getStringStorage(key);
    if (m_data !== null) {
      return JSON.parse(m_data);
    } else { return null; }
  } catch (e) {
    return null;
  }
}

export function getStringStorage(key) {
  var m_data = localStorage.getItem(key);
  if (m_data === null) {
    return null;
  } else {
    // WHEN STORAGE DATA IS EXIST THEN RETURN STRING DATA
    return m_data;
  }
}

export function saveStorage(key, data) {
  if (data === undefined) { data = null; }
  if (data !== null) {
    localStorage.setItem(key, data);
  }
}

export function removeStorage(key) {
  localStorage.removeItem(key);
}
